import React, { Fragment, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
	Button,
	Form,
	FormGroup,
	Input,
	Label,
	Media,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
} from "reactstrap";
import axiosInstance from "../axios";

const DatatableCity = ({ myData, myClass, HandleRender, pagination }) => {
	const [open, setOpen] = useState(false);
	const [formData, updateFormData] = useState(null);
	// loader start
	const [pending, setPending] = useState(true);
	const [rows, setRows] = useState([]);

	useEffect(() => {
		if (!myData) {
			setPending(true);
		} else {
			setRows(myData);
			setPending(false);
		}
	}, [myData]);
	// loader end

	const handleChange = (e) => {
		updateFormData({
			...formData,
			// Trimming any whitespace
			[e.target.name]: e.target.value,
		});
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		if (formData) {
			axiosInstance
				.patch(`/admin/delivery-city/${rowData.id}`, formData)
				.then((res) => {
					updateFormData(null);
					HandleRender();
					onCloseModal("VaryingMdo");
					toast.success("تم تعديل البيانات بنجاح!");
				})
				.catch((err) => {
					if (err.response.status === 400) {
						toast.warning(`تاكد من البيانات المدخلة`);
					} else {
						toast.error(`${err.response.status} تاكد من البيانات المدخلة`);
					}
				});
		}
	};
	const handleSubmitDelete = (row) => {
		if (window.confirm("هل تريد اخفاء هذه المدينة ؟")) {
			axiosInstance
				.patch(`/admin/delivery-city/${row.id}`, { is_deleted: !row.is_deleted })
				.then((res) => {
					updateFormData(null);
					HandleRender();
					toast.success("تم الاخفاء");
				})
				.catch((err) => {
					console.error(err);
					toast.error("حدث خطأ ما");
				});
		}
	};

	const onOpenModal = () => {
		setOpen(true);
	};

	const onCloseModal = () => {
		setOpen(false);
	};

	const [rowData, setRowData] = useState(null);

	const columns = [
		{
			id: "id",
			name: "Id",
			selector: (row) => row.id,
			style: {
				textAlign: "center",
			},
		},
		{
			id: "name_ar",
			name: "الاسم عربى",
			sortable: true,

			selector: (row) => row.name_ar,

			style: {
				textAlign: "center",
			},
		},
		{
			id: "name_en",
			name: "الاسم انجليزي",
			sortable: true,

			selector: (row) => row.name_en,
			style: {
				textAlign: "center",
			},
		},
		{
			id: "price",
			name: "السعر",
			sortable: true,

			selector: (row) => row.price,
			style: {
				textAlign: "center",
			},
		},

		{
			id: "is_deleted",
			name: "مخفى",
			cell: (row) => {
				return <div>{row.is_deleted.toString() === "true" ? "مخفى" : "مرئى"}</div>;
			},
			style: {
				textAlign: "center",
			},
		},
	];

	columns.push({
		name: <b>عمليات</b>,
		id: "delete",
		accessor: (str) => "delete",
		cell: (row, index) => (
			<div>
				<span
					onClick={(e) => {
						handleSubmitDelete(row);
						setRowData(row);
					}}>
					<i
						className="fa fa-trash"
						style={{
							width: 35,
							fontSize: 20,
							padding: 11,
							color: "#e4566e",
						}}></i>
				</span>

				<span>
					<i
						onClick={(e) => {
							setRowData(row);
							onOpenModal();
						}}
						className="fa fa-pencil"
						style={{
							width: 35,
							fontSize: 20,
							padding: 11,
							color: "rgb(40, 167, 69)",
						}}></i>
					<Modal
						isOpen={open}
						toggle={onCloseModal}
						style={{ overlay: { opacity: 0.1 } }}>
						<ModalHeader toggle={onCloseModal}>
							<h6 className="modal-title f-w-600" id="exampleModalLabel2">
								تعديل المحافظة{" "}
							</h6>
						</ModalHeader>
						<ModalBody>
							<Form>
								<FormGroup>
									<Label htmlFor="recipient-name" className="col-form-label">
										الاسم عربى :
									</Label>
									<Input
										type="text"
										name="name_ar"
										className="form-control"
										onChange={handleChange}
										defaultValue={rowData?.name_ar}
									/>
								</FormGroup>
								<FormGroup>
									<Label htmlFor="recipient-name" className="col-form-label">
										الاسم انجليزي :
									</Label>
									<Input
										type="text"
										name="name_en"
										className="form-control"
										onChange={handleChange}
										defaultValue={rowData?.name_en}
									/>
								</FormGroup>
								<FormGroup>
									<Label htmlFor="recipient-name" className="col-form-label">
										السعر:
									</Label>
									<Input
										type="text"
										name="price"
										className="form-control"
										onChange={handleChange}
										defaultValue={rowData?.price}
									/>
								</FormGroup>
							</Form>
						</ModalBody>
						<ModalFooter className="d-flex justify-content-between">
							<Button
								type="button"
								color="secondary"
								onClick={(e) => {
									handleSubmit(e);
								}}>
								تعديل
							</Button>
							<Button
								type="button"
								color="primary"
								onClick={() => onCloseModal("VaryingMdo")}>
								اغلاق
							</Button>
						</ModalFooter>
					</Modal>
				</span>
			</div>
		),
		style: {
			textAlign: "center",
		},
		sortable: false,
	});

	return (
		<div>
			<Fragment>
				<DataTable
					data={myData}
					columns={columns}
					rows={rows}
					progressPending={pending}
					className={myClass}
					pagination={pagination}
					striped={true}
					center={true}
				/>

				<ToastContainer autoClose={2000} rtl />
			</Fragment>
		</div>
	);
};

export default DatatableCity;
